export enum OS {
    ANDROID = 'android',
    IOS = 'ios'
}

export const ANDROID: OS = OS.ANDROID;
export const IOS: OS = OS.IOS;

export const platform = (): OS => {
    const navigator: any = window.navigator.userAgent;
    return /android/i.test(navigator) ? ANDROID : IOS;
};

export const IS_PLATFORM_IOS: boolean = platform() === IOS;
export const IS_PLATFORM_ANDROID: boolean = platform() === ANDROID;
